import React from 'react'
import CommonBanner from '@/components/CommonComponent/Common-Banner'
import { StyledWrapper } from '@/components/Styled'
const Page = ({ other }: any) => {
  return (
    <>
      { <div>
          {
            other?.title &&
            <div className='w-full px-4 bg-[url("/images/blog-bg.png")] h-[45vh] flex justify-center items-center'>
              <h1 className='text-[32px] lg:text-[44px] text-center font-bold text-white'> {other?.title || ''}</h1>
            </div>
          }
          {other?.banner_title && other?.banner_desc &&
            <CommonBanner title={other?.banner_title} description={other?.banner_desc} image={other?.banner_img} image_alt={other?.bannerimg_alt}
              btntext={other?.button_text} btnlink={other?.button_url} />
          }
          <div className='w-full px-6  xl:w-[95%]  2xl:w-[80%] mx-auto py-12'>
            <StyledWrapper>
              <div className='text-homeblack' dangerouslySetInnerHTML={{ __html: other?.body }} />
            </StyledWrapper>
          </div>
        </div>
      }
    </>
  )
}

export default Page
